import {apiResourceName, useFetchTarget} from './useFetchTarget';
import {useQuery} from '@tanstack/react-query';

export const useQueryTargetIndex = ({params, useQueryOptions}) => {
	const {index} = useFetchTarget();
	return useQuery({
		queryKey: [`${apiResourceName}`, 'index', params],
		queryFn: () => index(params),
		staleTime: 60 * 1000,
		...useQueryOptions,
	});
};

export const useQueryTargetById = ({params, useQueryOptions}) => {
	const {byId} = useFetchTarget();
	return useQuery({
		queryKey: [`${apiResourceName}`, 'byId', params],
		queryFn: () => byId(params),
		...useQueryOptions,
	});
};
